import { MapApi } from "./map.js";
import { AtlasApi } from "./atlas.js";
import { StyleUrl } from "./style.js";
import { TemplateApi } from "./template.js";
import * as Options from "./options.js";
import * as Url from "./url.js";
import { ApiEntity } from "../types/main.js";
export const CoreApi = {
    Map: MapApi,
    Atlas: AtlasApi,
    Style: StyleUrl,
    Template: TemplateApi,
    Stats: Url.getBaseUrl(ApiEntity.Stats),
    Options,
    Url,
};
